import { SummaryTable } from "./SummaryTable";

export default SummaryTableimport { SummaryTable } from "./SummaryTable";

export default SummaryTable